<template>
	<component v-if="loadedComponent" :is="loadedComponent" :ref="setChildrenRefs" v-bind="$attrs" v-on="$listeners">
		<template v-slot:default="slotProps">
			<slot v-bind="slotProps ?? {}" />
		</template>
	</component>
</template>

<script>
export default {
	name: 'SmartLayoutComponent',
	inheritAttrs: false
};
</script>

<script setup>
import { shallowRef, ref, onMounted } from 'vue';
import { useComponentResolver } from '@rebuild/hooks/comp/useComponentResolver.js';

const props = defineProps({
	compId: {
		type: String,
		default: ''
	},
	mode: {
		type: String,
		default: ''
	}
});

const { resolveComponent } = useComponentResolver('layout');
const loadedComponent = shallowRef(null);
onMounted(() => {
	const result = resolveComponent(props.compId, props.mode);
	if (result?.component) {
		loadedComponent.value = result.component;
	}
});

const childrenRefs = ref(null);
const setChildrenRefs = el => {
	childrenRefs.value = el;
};
defineExpose({
	get child() {
		return childrenRefs.value;
	}
});
</script>
